import { getSafety } from '~/utils';
import { formatAppliedFilters } from '~/analytics/analytics.utils';
import { services } from '~/ocab-services/services.constant';
import { config as envConfig } from 'ENV_CONFIG';

export const getAppointmentsDetails = (
  appointmentType = getSafety(window, 'jlData.page.appointments.filters.appointmentType'),
  filterApplied = getSafety(window, 'jlData.page.appointments.filters.filterApplied', 'categories:none^brands:none'),
  noOfResults = getSafety(window, 'jlData.page.appointments.filters.noOfResults', 0),
  stylistLevel = getSafety(window, 'jlData.page.appointments.stylistLevel', 'default'),
) => ({
  journey: envConfig.services[services.BEAUTY.name]?.analyticsJourneyName,
  branchId: getSafety(window, 'jlData.page.appointments.branchId', ''),
  appointmentType,
  filters: {
    filterApplied,
    noOfResults,
  },
  stylistLevel,
});

export const getAnalyticsData = ({ numberOfTreatments, stylistLevel, selectedFacets }) => ({
  journey: envConfig.services[services.BEAUTY.name].analyticsJourneyName,
  filters: {
    filterApplied: selectedFacets && formatAppliedFilters(selectedFacets.map(({ group, value }) => ({ group, name: value }))),
    noOfResults: numberOfTreatments || getSafety(window, 'jlData.page.appointments.filters.noOfResults', 0),
  },
  stylistLevel: stylistLevel || getSafety(window, 'jlData.page.appointments.stylistLevel', 'default'),
});
